import { msg } from 'api';

export const BetaFeatures = {
  HEALTHIFY: 'HEALTHIFY',
  ACCOUNT_SETTINGS_RAVEN: 'ACCOUNT_SETTINGS_RAVEN',
  ACCOUNT_SETTINGS_SHOW_IMPORT_FAVOURITES_LINK: 'ACCOUNT_SETTINGS_SHOW_IMPORT_FAVOURITES_LINK',
  SSO_CHANGE_CREDENTIALS: 'SSO_CHANGE_CREDENTIALS',
  YOUR_SAVINGS_HUB_LINK: 'YOUR_SAVINGS_HUB_LINK',
  ONE_TRUST_COOKIES: 'ONE_TRUST_COOKIES',
  LEGITIMATE_INTEREST: 'LEGITIMATE_INTEREST',
};

export const Features = {
  PAYPAL_LOGIN: 'PAYPAL_LOGIN',
  GDPR_MARKETING_COMMUNICATIONS: 'GDPR_MARKETING_COMMUNICATIONS',
  RAVEN_ALTERNATIVE_PREFERENCE_CENTER: 'RAVEN_ALTERNATIVE_PREFERENCE_CENTER',
};

export const addressBookErrorMessages = {
  UNKNOWN_ERROR: msg.settings.deliveryAddressBook.errorMessages.unknownError,
  ADDRESS_IN_USE_FOR_ORDERS_RESERVED: msg.settings.deliveryAddressBook.errorMessages.addressInUseForOrdersReserved,
  ADDRESS_WITH_PENDING_ORDER: msg.settings.deliveryAddressBook.errorMessages.addressWithPendingOrder,
  ADDRESS_WITH_BOOKED_DELIVERY_SLOT: msg.settings.deliveryAddressBook.errorMessages.addressWithBookedDeliverySlot,
  POSTCODE_NOT_IN_DELIVERY_AREA: msg.settings.deliveryAddressBook.errorMessages.notInDeliveryArea,
};

export const usagesTypesNames = msg.settings.storedPaymentDetails.types;

// Validator messages for backend validation error codes:
export const addressBookValidationMessages = {
  outOfZone: msg.settings.deliveryAddressBook.addressBookValidationMessages.outOfZone,
  invalidPostcode: 'That doesn\'t seem right. Please enter a valid postcode.',
  unknownError: msg.settings.deliveryAddressBook.addressBookValidationMessages.unknownError,
  cannotBeBlank: 'Required field',
  OSPZone: msg.settings.deliveryAddressBook.addressBookValidationMessages.ospZone,
};
